import formatCurrency from "@utils/format-currency";

export default function formatPrice(price) {
  return Number(price) > 0
    ? `NT$ ${formatCurrency(price)}`
    : '免費(NT$ 0)'
}

export function formatPriceRange(minPriice, maxPriice) {
  if(minPriice === maxPriice) {
    return `NT$ ${formatCurrency(minPriice)}`
  } else 
  return `NT$ ${formatCurrency(minPriice)} - $${formatCurrency(maxPriice)}`
}
